var render = function () {
  var _vm$translations, _vm$translations2, _vm$translations3, _vm$imageRequirements, _vm$imageRequirements2, _vm$imageRequirements3, _vm$translations4, _vm$imageRequirements4, _vm$imageRequirements5, _vm$imageRequirements6, _vm$translations5, _vm$imageRequirements7, _vm$imageRequirements8, _vm$translations6, _vm$imageRequirements9, _vm$imageRequirements0, _vm$imageRequirements1, _vm$translations7, _vm$translations8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "molecule-ugc-error-image",
      "elementType": "section"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-main-views-wrapper",
      "elementType": "section",
      "id": "customs-vmodal-dialog-desc"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "logo",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-monitor-error.svg"),
      "role": "img"
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "h1",
      "customClass": "ugc-icon-error-text error-text",
      "text": (_vm$translations = _vm.translations) === null || _vm$translations === void 0 ? void 0 : _vm$translations.ugcImageErrorIconText
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "h1",
      "id": "customs-vmodal-header-title",
      "text": (_vm$translations2 = _vm.translations) === null || _vm$translations2 === void 0 ? void 0 : _vm$translations2.ugcImageErrorTitle
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "description-error",
      "elementType": "p",
      "text": (_vm$translations3 = _vm.translations) === null || _vm$translations3 === void 0 ? void 0 : _vm$translations3.ugcImageErrorDescription
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "error-list-wrapper",
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "error-item-list",
      "elementType": "ul"
    }
  }, [_vm.productType === _vm.productTypes.FOOTWEAR ? _c('CustomContainer', {
    attrs: {
      "customClass": "error-item",
      "elementType": "div"
    }
  }, [((_vm$imageRequirements = _vm.imageRequirements) === null || _vm$imageRequirements === void 0 ? void 0 : _vm$imageRequirements.imageDimensions) === true ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "pass-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-success-circle.svg"),
      "role": "svg"
    }
  })], 1) : _vm._e(), ((_vm$imageRequirements2 = _vm.imageRequirements) === null || _vm$imageRequirements2 === void 0 ? void 0 : _vm$imageRequirements2.imageDimensions) === false ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "error-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-warning-error-circle.svg"),
      "role": "svg"
    }
  })], 1) : _vm._e(), _c('CustomText', {
    attrs: {
      "customClass": "".concat(((_vm$imageRequirements3 = _vm.imageRequirements) === null || _vm$imageRequirements3 === void 0 ? void 0 : _vm$imageRequirements3.imageDimensions) === false ? 'error-text' : ''),
      "elementType": "span",
      "text": (_vm$translations4 = _vm.translations) === null || _vm$translations4 === void 0 ? void 0 : _vm$translations4.ugcImageErrorItem1
    }
  })], 1) : _vm._e(), _vm.productType !== _vm.productTypes.FOOTWEAR ? _c('CustomContainer', {
    attrs: {
      "customClass": "error-item",
      "elementType": "div"
    }
  }, [((_vm$imageRequirements4 = _vm.imageRequirements) === null || _vm$imageRequirements4 === void 0 ? void 0 : _vm$imageRequirements4.imageDimensions) === true ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "pass-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-success-circle.svg"),
      "role": "img"
    }
  })], 1) : _vm._e(), ((_vm$imageRequirements5 = _vm.imageRequirements) === null || _vm$imageRequirements5 === void 0 ? void 0 : _vm$imageRequirements5.imageDimensions) === false ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "error-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-warning-error-circle.svg"),
      "role": "img"
    }
  })], 1) : _vm._e(), _c('CustomText', {
    attrs: {
      "customClass": "".concat(((_vm$imageRequirements6 = _vm.imageRequirements) === null || _vm$imageRequirements6 === void 0 ? void 0 : _vm$imageRequirements6.imageDimensions) === false ? 'error-text' : ''),
      "elementType": "span",
      "text": (_vm$translations5 = _vm.translations) === null || _vm$translations5 === void 0 ? void 0 : _vm$translations5.ugcImageErrorItem2
    }
  })], 1) : _vm._e(), _c('CustomContainer', {
    attrs: {
      "customClass": "error-item",
      "elementType": "li"
    }
  }, [((_vm$imageRequirements7 = _vm.imageRequirements) === null || _vm$imageRequirements7 === void 0 ? void 0 : _vm$imageRequirements7.imageType) === true ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "pass-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-success-circle.svg"),
      "role": "img"
    }
  })], 1) : _vm._e(), ((_vm$imageRequirements8 = _vm.imageRequirements) === null || _vm$imageRequirements8 === void 0 ? void 0 : _vm$imageRequirements8.imageType) === false ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "error-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-warning-error-circle.svg"),
      "role": "img"
    }
  })], 1) : _vm._e(), _c('CustomText', {
    attrs: {
      "customClass": "".concat(_vm.imageRequirements.imageType === false ? 'error-text' : ''),
      "elementType": "span",
      "text": (_vm$translations6 = _vm.translations) === null || _vm$translations6 === void 0 ? void 0 : _vm$translations6.ugcImageErrorItem3
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "error-item",
      "elementType": "li"
    }
  }, [((_vm$imageRequirements9 = _vm.imageRequirements) === null || _vm$imageRequirements9 === void 0 ? void 0 : _vm$imageRequirements9.imageSize) === true ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "pass-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-success-circle.svg"),
      "role": "svg"
    }
  })], 1) : _vm._e(), ((_vm$imageRequirements0 = _vm.imageRequirements) === null || _vm$imageRequirements0 === void 0 ? void 0 : _vm$imageRequirements0.imageSize) === false ? _c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomSvgIcon', {
    attrs: {
      "customClass": "error-requirement",
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-warning-error-circle.svg"),
      "role": "svg"
    }
  })], 1) : _vm._e(), _c('CustomText', {
    attrs: {
      "customClass": "".concat(((_vm$imageRequirements1 = _vm.imageRequirements) === null || _vm$imageRequirements1 === void 0 ? void 0 : _vm$imageRequirements1.imageSize) === false ? 'error-text' : ''),
      "elementType": "span",
      "text": (_vm$translations7 = _vm.translations) === null || _vm$translations7 === void 0 ? void 0 : _vm$translations7.ugcImageErrorItem4
    }
  })], 1)], 1)], 1), _c('CustomText', {
    attrs: {
      "customClass": "terms-conditions",
      "href": "/terms-conditions.html",
      "elementType": "a",
      "text": (_vm$translations8 = _vm.translations) === null || _vm$translations8 === void 0 ? void 0 : _vm$translations8.ugcImageErrorTermsConditions
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }